<template>
	<el-row class="homemainbigbox">
		<el-row class="main">
			<mainOne></mainOne>
			<mainTwo></mainTwo>
			<mainThree></mainThree>
			<foot></foot>
		</el-row>
	</el-row>
</template>

<script>
	import mainOne from './components/mainOne.vue';
	import mainTwo from './components/mainTwo.vue';
	import mainThree from './components/mainThree.vue';
	import foot from '@/views/foot/index.vue';
 export default {
		components:{
			mainOne:mainOne,
			mainTwo:mainTwo,
			mainThree:mainThree,
			foot:foot,
		},
        data(){
          return{

          }
        },
        methods:{

        },

}
</script>

<style lang="less" scoped>
	.homemainbigbox {
		width: 100%;
		height: auto;
		.main{
			height: auto;
			width: 100%;
		}
	}
</style>
